export default {"src":"/_next/static/media/EHACare-ConfigPerson.5dcb75f8.svg","height":132,"width":142};